import { execQuery, extractUserSet } from "../api";
import { SqlDataTable } from "../components/SqlDataTable";
import { SqlPieChart } from "../components/SqlPieChart";
import { openExportUsersModal } from "@/components/elements/ExportUsersModal";

interface Data { name: string, value: number, min: number, max: number };

const dataQuery = `
  select
    CASE WHEN value >= 22 THEN '22 Page views or more this month' WHEN
    value >= 10  THEN '10 Page views or more this month' WHEN 
    value >= 5  THEN '5 Page views or more this month' else 'Less than 5 days' END as name,
    CASE WHEN value >= 22 THEN 22 WHEN
    value >= 10  THEN 10 WHEN 
    value >= 5  THEN 5 else 1 END as min,
    CASE WHEN value >= 22 THEN 10000 WHEN
    value >= 10  THEN 21 WHEN 
    value >= 5  THEN 9 else 4 END as max,
    count(distinct user_id) as value
  from (
    select 
      count(*) as value,
      user_id as user_id,
    from events
    where epoch_ms(ts) > (now() - INTERVAL 30 DAY) and epoch_ms(ts) <= now()
    and (label like 'article%' or label = 'trending')
    and user_id is not null
    group by user_id
    having value > 5
  ) data
  group by name, min, max
  order by value
`;

const extractUsersQuery = `
    select 
      count(*) as value,
      user_id as user_id,
    from events
    where epoch_ms(ts) > (now() - INTERVAL 30 DAY) and epoch_ms(ts) <= now()
    and (label like 'article%' or label = 'trending')
    and user_id is not null
    group by user_id
    having value >= ? and value < ?
`

export function UserVisitsByView() {
  return <SqlDataTable
    label="Users by page views"
    subtext="Users who have viewed MXM x times in the last 30 days. (Last 30 days)"
    width={1200}
    onClick={(data: Data) => {
      let users: Set<string>;
      openExportUsersModal({
        headerContent: <>
          Include only users who have have <b>{data.name}</b>.
        </>,
        onDownload: async () => {
          users = await extractUserSet(extractUsersQuery, [data.min, data.max])
        },
        beforeCsv: async (exportUsers) => {
          return exportUsers.filter(u => users.has(u.id));
        }
      })
    }}
  >{dataQuery}</SqlDataTable>
}